import { LocationType } from "../../apis/networkdashboard/graphql/graphql";

export const formatLocationLabel = (location: LocationType): string => {
  const address = location.address;
  const city = address?.city?.toLowerCase() ?? "-";
  const street = address?.street?.toLowerCase() ?? "-";
  const number = address?.number ?? "-";
  return `${city} (${street} ${number})`;
};

export const collectLocations = (subscriptions: { description: string; locations?: LocationType[] }[]): string[] => {
  const labels = subscriptions.flatMap((s) => s.locations ?? []).map(formatLocationLabel);
  return [...new Set(labels)].sort();
};
